import React, { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogClose, DialogTrigger } from "../../@/components/ui/dialog";
import { Button } from "../../@/components/ui/button";
import { toast } from "sonner";
import axios from "axios";
import { api_endpoint } from "@/constants/constant";
import { useAuth } from "@clerk/clerk-react";
import { ClipLoader } from "react-spinners";

export default function DeleteQuiz({ quizId, quizTitle, onDeleted, triggerButtonProps = {} }) {
    const [open, setOpen] = useState(false)
    const [loading, setLoading] = useState(false)
    const { getToken } = useAuth()

    const handleDelete = async () => {
        setLoading(true)
        try {
            const token = await getToken()
            if (!token) return
            const reqConfig = {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`
                }
            }
            await axios.delete(api_endpoint + `/quiz/${quizId}`, reqConfig)
            toast.success(`Quiz "${quizTitle}" deleted successfully!`)
            setOpen(false)
            if (onDeleted) onDeleted(quizId)
        } catch (error) {
            toast.error(`Failed to delete quiz "${quizTitle}".`)
        } finally {
            setLoading(false)
        }
    }

    return (
        <Dialog open={open} onOpenChange={setOpen}>
            <DialogTrigger asChild>
                <Button
                    variant="outline"
                    size="sm"
                    className="text-red border-red hover:bg-blue hover:border-transparent hover:text-white"
                    {...triggerButtonProps}
                >
                    Delete Quiz
                </Button>
            </DialogTrigger>
            <DialogContent className="max-w-md h-auto">
                <DialogHeader>
                    <DialogTitle className="font-heading">Delete Quiz</DialogTitle>
                </DialogHeader>
                <div className="font-body">
                    Are you sure you want to delete the quiz <b>{quizTitle}</b>? This action cannot be undone.
                </div>
                <DialogFooter className="">
                    <DialogClose asChild>
                        <Button variant="outline" onClick={() => setOpen(false)} disabled={loading} className="font-body">
                            Cancel
                        </Button>
                    </DialogClose>
                    <Button
                        variant=""
                        onClick={handleDelete}
                        disabled={loading}
                        className=""
                    >
                        {loading ? (
                            <span className="flex items-center justify-center w-full">
                                <ClipLoader size={20} color="#fff" />
                            </span>
                        ) : (
                            "Delete"
                        )}
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    )
}